import { Navigate } from 'react-router-dom';
import { useStore } from '../../common/stores/store';
import { EMPLOYEE_ROLE } from '../../constants';
import { Public_Routes } from '../../constants/Routes';
import EmployeeAuthenticatedLayout from '../../common/layout/EmployeeAuthenticatedLayout';
import SchedulingAuthenticatedLayout from '../../common/layout/SchedulingAuthenticatedLayout';

const AuthRouter = () => {
    const { commonStore } = useStore();

    return commonStore.token && commonStore.user?.role.name == EMPLOYEE_ROLE ? (
        <EmployeeAuthenticatedLayout />
    ) : commonStore.token ? (
        <SchedulingAuthenticatedLayout />
    ) : (
        <Navigate replace to={Public_Routes.LOGIN} />
    );
};

export default AuthRouter;
